import { render, staticRenderFns } from "./headPanel.vue?vue&type=template&id=50f572f8&scoped=true&"
import script from "./headPanel.vue?vue&type=script&lang=js&"
export * from "./headPanel.vue?vue&type=script&lang=js&"
import style0 from "./headPanel.vue?vue&type=style&index=0&id=50f572f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f572f8",
  null
  
)

export default component.exports